import ConnectionStatus from "components/ConnectionStatus";
import BasicButton from "components/General/BasicButton";
import React, {
  useEffect,
} from "react";
import { Link } from "react-router-dom";
import { useWebSocket } from "WebSocketContext";

import BackButton from "components/BackButton";

const Play: React.FC = () => {
  const { isConnected, playerId, reconnect } = useWebSocket();

  useEffect(() => {
    reconnect();
  }, [])

  return (
    <div className="h-[100vh] flex flex-col justify-center items-center text-center">
      <ConnectionStatus />
      <h1 className="text-3xl font-bold text-bold">A Wetland Role-Playing Game to Activate Pluriversal Perspectives</h1>
      <h1 className="text-2xl m-2 mt-8">Ready to start a game?</h1>
      <div className="flex flex-col md:flex-row gap-4 text-base">
        <Link to="/play/create"><BasicButton text="Create Game" className="py-4 px-8 w-64"/></Link>
        <Link to="/play/join"><BasicButton text="Join Game" className="py-4 px-8 w-64"/></Link>
      </div>
      <Link to="/about"><BasicButton text="About" className="m-4 py-4 px-8 w-64 text-base"/></Link>

      
      <BackButton />
    </div>
  );
};

export default Play;
